import { FC } from 'react';
import { makeStyles, Typography } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.NEUTRAL300,
  },
}));

export const HelperText: FC<{ error?: boolean }> = ({ children, error }) => {
  const classes = useStyles();
  return (
    <Typography
      className={classes.text}
      style={!!error ? { color: 'red' } : null}
      variant="caption"
    >
      {children}
    </Typography>
  );
};
